import React from 'react';
import Messages from '../i18n';
export var MessageContext = React.createContext({
    msg: Messages.get(undefined),
});
